import React, {useState, useContext} from 'react';
import { Form, Input, Button } from 'antd';
import {useRouter} from 'next/router'

import { pushRouteLogin } from '../auth/LoginRouting';
import {callApi} from '../../helpers/Api';
import UserContext from '../../context/UserContext';

const Editor = ({ parentId=null, storyId, path, handleSubmitRes, ...props }) => {
    const {loggedInUser} = useContext(UserContext);
    const [value, setValue] = useState(null)
    const [submitting, setSubmitting] = useState(false)
    const router = useRouter();

    const onSubmit = e => {
        if (!e) {
            return;
        }

        setSubmitting(true);
    
        setTimeout(() => {
            setSubmitting(false);
            setValue('');

            if(loggedInUser) {
                var body = {
                    parent_id: parentId,
                    story_id: storyId,
                    path: path,
                    comment_body: value,
                }

                callApi('/api/own/story_comment',{
                    method: 'POST',
                    body: JSON.stringify(body)
                })
                .then(([res]) => {
                    handleSubmitRes(res);

                    callApi('/api/notification/comment',{
                        method: 'POST',
                        body: JSON.stringify({
                            id: res.id,
                        })
                    })
                });
            } else {
                pushRouteLogin(router)
            }
        }, 0);
    };

    const onChange = e => {
        if(!loggedInUser)
            pushRouteLogin(router)
        setValue(e.target.value);
    };

    return (
        <div>
            <Form.Item>
                <Input.TextArea className="medium-darkable" rows={4} onChange={onChange} value={value} />
            </Form.Item>
            <Form.Item>
                <Button htmlType="submit" loading={submitting} onClick={onSubmit} type="primary">
                    add comment
                </Button>
            </Form.Item>
        </div>
    );
}

export default Editor;